import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function PainPoints() {
  const points = ['Te prometiste que "esta semana sí"… y el martes ya estás improvisando.', 'Te cansaste de recetas perfectas que no se adaptan a tu casa, tu bolsillo, ni tu energía.', 'Sentís que pensar la comida te ocupa la cabeza todo el día.', 'Tenés miedo de equivocarte y después pagarlo con culpa.'];
  return <Section className="bg-sage-light/30 rounded-3xl my-8" data-id="element-99">
      <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-100">
        Si esto te pasa, no estás sola
      </h2>

      <ul className="space-y-6 mb-10" data-id="element-101">
        {points.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-102">
            <CheckCircle2 className="w-6 h-6 text-sage mt-1 flex-shrink-0" data-id="element-103" />
            <span className="text-lg text-brown-body" data-id="element-104">{point}</span>
          </li>)}
      </ul>

      <div className="text-center" data-id="element-105">
        <p className="text-2xl font-serif font-medium text-amber italic" data-id="element-106">
          "No es falta de ganas. Es falta de sistema."
        </p>
      </div>
    </Section>;
}